import { responsiveFontSizes } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import shadows from './shadows';
import { light, dark } from './palette';

const getTheme = (mode, themeToggler) =>
  responsiveFontSizes(
    createTheme({
      palette: mode === 'light' ? light : dark,
      shadows: shadows(mode),
      typography: {
        fontFamily: '"Lato", sans-serif',
        button: {
          textTransform: 'none',
          fontWeight: 'medium',
        },
        psmall: {
          fontSize:10,
        },
        pgreen: {
          fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
          color:"green",
          fontSize:14,
        },
        pred: {
          fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
          color:"red",
          fontSize:14,
        },
      },
      zIndex: {
        appBar: 1200,
        drawer: 1300,
      },
      components: {
        MuiButton: {
          styleOverrides: {
            label: {
              fontWeight: 600,
            },
            containedSecondary: mode === 'light' ? { color: 'white' } : {},
          },
        },
      },
      themeToggler,
    }),
  );

export default getTheme;
